<template>
    <div>
      <b-modal ref="user-validate-modal" id="modal" modal-class="user-validate-modal" no-close-on-esc no-close-on-backdrop hide-header-close hide-footer>
        <div class="text-center" v-if="isloading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
        <p class="my-4 text-center">{{labels.VerifyYourAccountPleaseWait}}</p>
      </b-modal>
  </div>
</template>

<script>
import { vcm } from '@/mixins/vcm'
import { vvm } from '@/mixins/vvm'
import axios from 'axios';
export default {
    name: 'userValidation',
    mixins:[vcm, vvm],
    data() {
    return {
      isloading: false,
      forsignin : null,
      forresetpassword: null,
      useruuid: null,
      labels: {
        VerifyYourAccountPleaseWait: this.get_scope_translation("VerifyYourAccountPleaseWait", "label"),
      },
      data: {},
    };
  },


async created() {
      
},

async mounted() {
      this.showModal();
      this.isloading = true;
      const queryParams = new URLSearchParams(window.location.search);
      let decodeUrl = decodeURIComponent(window.location.href);
      this.useruuid = queryParams.get("useruuid");
      this.forsignin = queryParams.get("forsignin");
      this.forresetpassword = queryParams.get("forresetpassword");
      let code = decodeUrl && decodeUrl.split('&') && decodeUrl.split('&')[2] && decodeUrl.split('&')[2].split(/=(.+)/)[1]
      if(this.useruuid && code  && this.forsignin 
      && this.forresetpassword 
      ) {
        this.$root.data_access.setIdentifier("user.double.optin.activation");
        this.$root.data_access.setReceiver("component", this);
        this.data = {
          TypeName : 'DoubleOptInEMail',
          Code : code
        };
        this.$root.data_access.addPathParameter('user-uuid',this.$root.get_user_info('useruuid', this.useruuid)) 
        this.$root.data_access.setRequestBody(this.data);
        this.$root.data_access.call("user_double_optin_activation");
      } else {
          this.$router.push({name: 'notfound'});
          return;
      }
},
methods:{
     showModal() {
        this.$refs['user-validate-modal'].show()
      },

     receive : function(dataObject) {
      if (dataObject) {
        switch (dataObject.identifier) {
          case "user.double.optin.activation":
              if (dataObject.data) {
                if (!dataObject.data.response) {
                axios.post( 
                  process.env.VUE_APP_BASE_URL + `/v1/users/${this.useruuid}/doubleoptin`, {
                    TypeName : this.data.TypeName,
                    Code : this.data.Code
                  },
                ).then((result) => {
                   if(result.data.responseCode == '200' && result.data.responseMessage == 'Ok') {
                    if(this.forsignin) {
                      window.location.href = `anmeldung?status=success`;
                    } else {
                      window.location.href = `anmeldung?status=failed`;
                    }
                  } else {
                    window.location.href = `anmeldung?status=failed`;
                  }
                }).catch((error)=> {
                  console.log("error", error);
                });
                }
              }
            break;
        }
      }
    },
}
}
</script>

<style lang="css">
.user-validate-modal {
    display: flex !important;
    justify-content: center  !important;
    align-items: center  !important;
    height: 100vh;
}
.user-validate-modal > div {
    width: 80%  !important;
}

div#modal .modal-dialog.modal-md .modal-content > header {
    border-bottom: 0 !important;
}
.spinner-border  {
  color: #E3000F !important;
}
</style>